import React, { Component } from 'react';
import { withCookies } from 'react-cookie';
import { NotificationManager } from 'react-notifications';

// Services
import ticketsService from "@services/tickets";
import configService from "@services/config";

// Components
import EditableTable, { deleteColumnFormatter } from '@components/EditableTable'
import Button from "@components/Button";
import Input from "@components/Input";
import Switch from "@components/Switch";

import 'react-smarttab/dist/index.css'

import UserContext from '@components/context/userContext';

class Page extends Component {
    static contextType = UserContext;

    constructor(props) {
        super(props);

        this.state = {
            values: [],
            currency: '',
            configs: {},
            loaded: false,
        };

        this.loadFunction = this.loadFunction.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.onTableAddRow = this.onTableAddRow.bind(this);
        this.onTableDelRow = this.onTableDelRow.bind(this);
        this.onTableChange = this.onTableChange.bind(this);
    }

    async loadFunction() {
        const profile = this.context;

        if (!this.state.loaded) {
            try {
                // Load all data in parallel
                const [values, currency, configData] = await Promise.all([
                    ticketsService.getValues(profile.idEmpresa),
                    configService.getCurrency(profile.idEmpresa),
                    ticketsService.getConfig(profile.idEmpresa)
                ]);

                const hydratateConfigs = configData.reduce((acc, eachConfig) => {
                    return {
                        ...acc,
                        [eachConfig.key]: eachConfig.value,
                    }
                }, {});

                this.setState({ 
                    values: values.map((value, id) => ({
                        ...value,
                        id,
                    })), 
                    currency,
                    configs: hydratateConfigs,
                    loaded: true 
                });
            } catch (error) {
                console.error('Erro ao carregar dados:', error);
                NotificationManager.error('Erro ao carregar dados', 'Erro');
            }
        }
    }

    async handleChange(e, callback) {
        let value = e.target ? e.target.value : e ;
        let name = e.target.name;
        
        let newState = this.state;

        if (name.includes("|")) {
            const properties = name.split("|");
        
            newState[properties[0]][properties[1]] = value;
        
            this.setState({
                ...newState,
            });

            if (properties[0] === 'configs') {
                const profile = this.context;
                try {
                    await ticketsService.setConfig({
                        key: properties[1],
                        value,
                        idempresa: profile.idEmpresa,
                    });
                } catch (error) {
                    console.error('Erro ao definir configuração:', error);
                    NotificationManager.error('Erro ao definir configuração', 'Erro');
                }
            }
        } else {
            this.setState({
                [name]: value,
            });
        }
    }

    async handleBlur() {
        const profile = this.context;

        try {
            await configService.setCurrency({
                currency: this.state.currency,
                idempresa: profile.idEmpresa,
            });
        } catch (error) {
            console.error('Erro ao definir moeda:', error);
            NotificationManager.error('Erro ao definir moeda', 'Erro');
        }
    }

    async onTableSubmit() {
        const profile = this.context;

        try {
            await ticketsService.setValues({
                values: this.state.values.map((value) => value.value),
                idempresa: profile.idEmpresa,
            });
        } catch (error) {
            console.error('Erro ao definir valores:', error);
            NotificationManager.error('Erro ao definir valores', 'Erro');
        }
    }

    onTableAddRow() {
        const { values } = this.state;
        this.setState({ values: [ { id: Date.now(), value: '' }, ...values ]}, () => this.onTableSubmit());
    }

    onTableDelRow(cell, row) {
        const { values } = this.state;
        const result = values.filter((value) => value.id !== row.id);
        this.setState({ values: result }, () => this.onTableSubmit())
    }

    onTableChange(newValue, row, column) {
        const { values } = this.state;
        if (isNaN(newValue) || newValue <= 0) {
            return {
                valid: false,
                message: 'Apenas são permitidos valores positivos numéricos.'
            };
        }
        const allValues = values
            .filter((value) => value.id !== row.id)
        const unique = !allValues.find((value) => value.value === newValue);
        if (!unique) {
            return {
                valid: false,
                message: 'Não são permitidos valores repetidos.'
            };
        }
        const result = values.map((value) => {
            if (value.id === row.id) {
                const newRow = { ...value };
                newRow[column.dataField] = newValue;
                return newRow;
            }
            return value;
        });
        this.setState({ values: result }, () => this.onTableSubmit())
        return true;
    }

    render () {
        this.loadFunction()
        const { values, currency, loaded, configs } = this.state;
        return loaded ? (
            <>
                <h3>Moeda:</h3>
                <Input
                    inputType={"text"}
                    name={"currency"}
                    value={currency}
                    handleChange={this.handleChange}
                    onBlur={this.handleBlur}
                />
                <h3>Modo Fatura:</h3>
                <Switch
                    name={"configs|invoices"}
                    checked={configs.invoices}
                    handleChange={this.handleChange}
                />
                <h3>Valores:</h3>
                <Button
                    action={() => this.onTableAddRow()}
                    type={"success"}
                    title={(<><i className="fas fa-plus fa-lg"></i> Adicionar</>)}
                    style={{ marginBottom: '15px' }}
                />
                <EditableTable
                    columns={[
                        {
                            dataField: 'value',
                            text: 'Value',
                            validator: this.onTableChange,
                        }, {
                            dataField: 'delete',
                            text: 'Delete',
                            formatter: deleteColumnFormatter(this.onTableDelRow),
                            editable: false,
                        }
                    ]}
                    data={values} />
            </>
        ) : null;
    }
}

export default withCookies(Page);